/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Delete_PresetInputs */



/**
* | output |
* | --- |
* | "Delete Preset" |
*
* @param {Video_Export_Style_Delete_PresetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_delete_preset = /** @type {((inputs?: Video_Export_Style_Delete_PresetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Delete_PresetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le prereglage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellung löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina preimpostazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить предустановку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar ajuste preestablecido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir predefinição")
	return /** @type {LocalizedString} */ ("Delete Preset")
});